export default {
  inserted(el, binding) {
    function loadImage() {
      const imageSrc = binding.value;
      el.style.backgroundImage = `url(${imageSrc})`;
    }

    function handleIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersect, {
      threshold: 0.1,
    });

    observer.observe(el);
  },
};
